import React from 'react';

const AppFooter = () => (
    <footer className="App-footer">
        <span className="footer-text">
            {'This website template was made with React by '}
            <a className="App-link" href="https://www.brodyjohnstone.com">
                {'Brody Johnstone'}
            </a>
            {' and '}
            <a className="App-link" href="https://www.brandonmanuel.com">
                {'Brandon Manuel'}
            </a>
        </span>
    </footer>
);

export default AppFooter;